import React, { Component } from 'react';
import { connect, batch } from 'react-redux';
import { bindActionCreators } from 'redux';
import S from 'StyledAccountQueueBonus.js';
import { translation, formatMoney } from 'utilsHelper.js';
import { formatDate } from 'datesHelper.js';
import Loader from 'Loader.js';
import ModalOpacity from 'ModalOpacity.js';
import Pagination from 'Pagination.js';
import { proccessFrontError } from 'errorActions.js';
import { loadCustomerData } from 'customerActions.js';
import {
  setCurrentPage,
  fetchCreditBonusListByFilter,
  fetchCreditBonusListPending,
  fetchCreditBonusListFulfilled,
  fetchCreditBonusListFailure,
  manageCreditBonus,
} from 'accountBonusActions.js';
import CloseIcon from 'account_close_btn.png';

class AccountQueueBonus extends Component {
  state = {
    selectedOfferId: null,
    showConfirmationModal: false,
    showInfoModal: false,
    modalTitle: '',
    modalDescription: '',
    infoModalTitle: '',
    infoModalDescription: '',
    status: '',
  };

  componentDidMount = async () => {
    const { fetchCreditBonusListByFilter, processFrontError } = this.props;
    try {
      await fetchCreditBonusListByFilter({ activeTab: 'queue' });
    } catch (error) {
      processFrontError(error, 'AccountCurrentBonus.componentDidMount');
    }
  };

  goPage = (currentPage) => {
    const { fetchCreditBonusListByFilter, setCurrentPage, processFrontError } = this.props;
    try {
      batch(() => {
        setCurrentPage(currentPage);
        fetchCreditBonusListByFilter();
      });
    } catch (error) {
      processFrontError(error, 'AccountQueueBonus.goPage');
    }
  };

  setSelectedOfferId = (selectedOfferId) => {
    this.setState((prevState) => {
      return { ...prevState, selectedOfferId };
    });
  };

  setStatus = (status) => {
    this.setState((prevState) => {
      return { ...prevState, status };
    });
  };

  setInfoModalTextElements = (infoModalTitle, infoModalDescription) => {
    this.setState((prevState) => {
      return { ...prevState, infoModalTitle, infoModalDescription };
    });
  };

  setConfirmModalTextElements = (action) => {
    let modalTitle = '';
    let modalDescription = '';
    switch (action) {
      case 'activate':
        modalTitle = translation('account_bonus_activationTitle');
        modalDescription = translation('account_bonus_confirmActivate');
        break;
      case 'cancel':
        modalTitle = translation('account_bonus_cancellationTitle');
        modalDescription = translation('account_bonus_confirmCancel');
        break;
      case 'reject':
        modalTitle = translation('account_bonus_cancellationTitle');
        modalDescription = translation('account_bonus_confirmReject');
        break;
    }

    this.setState((prevState) => {
      return { ...prevState, modalTitle, modalDescription };
    });
  };

  toggleModal = (type) => {
    this.setState((prevState) => {
      return { ...prevState, [type]: !prevState[type] };
    });
  };

  renderBonusActionConfirmation = (offerId, status) => {
    this.setStatus(status);
    this.setConfirmModalTextElements(status);
    this.setSelectedOfferId(offerId);
    this.toggleModal('showConfirmationModal');
  };

  bonusActionAccept = async (offerId, action) => {
    const {
      manageCreditBonus,
      loadCustomerData,
    } = this.props;

    try {
      await manageCreditBonus(action, offerId);
      this.toggleModal('showConfirmationModal');
      this.toggleModal('showInfoModal');
      this.setInfoModalTextElements('success', '');
      loadCustomerData();
    } catch (error) {
      this.toggleModal('showConfirmationModal');
      this.toggleModal('showInfoModal');
      this.setInfoModalTextElements('error', translation(error));
    }
  };

  render() {
    const {
      showInfoModal,
      showConfirmationModal,
      modalTitle,
      modalDescription,
      infoModalTitle,
      infoModalDescription,
      status,
      selectedOfferId,
    } = this.state;
    const { isPending, bonus, currencyCode, limit } = this.props;
    const { data, currentPage, isNextPageAvailable } = bonus.queue;

    return (
      <S.AccountQueueBonus>
        {isPending ? (
          <Loader />
        ) : (
          <>
            <ModalOpacity
              isOpen={showConfirmationModal}
              showHeaderIcon={false}
              padding={0}
              title={modalTitle}
              toggleOpen={this.toggleModal.bind(this, 'showConfirmationModal')}
            >
              <S.ActivateModal>
                <S.Description>{modalDescription}</S.Description>

                <S.BtnsWrapper>
                  <S.ButtonCancel onClick={this.toggleModal.bind(this, 'showConfirmationModal')}>
                    {translation('common_cancel')}
                  </S.ButtonCancel>
                  <S.ButtonAccept
                    onClick={this.bonusActionAccept.bind(this, selectedOfferId, status)}
                  >
                    {translation('common_accept')}
                  </S.ButtonAccept>
                </S.BtnsWrapper>
              </S.ActivateModal>
            </ModalOpacity>

            <ModalOpacity
              isOpen={showInfoModal}
              showHeader={false}
              padding={0}
              toggleOpen={this.toggleModal.bind(this, 'showInfoModal')}
            >
              <S.ModalInfo>
                <S.CloseButton
                  src={CloseIcon}
                  onClick={this.toggleModal.bind(this, 'showInfoModal')}
                />
                <S.InfoTitle>{infoModalTitle}</S.InfoTitle>
                {infoModalDescription && (
                  <S.InfoDescription>{infoModalDescription}</S.InfoDescription>
                )}
              </S.ModalInfo>
            </ModalOpacity>

            <S.BonusListWrapper>
              {data.length > 0 ? (
                <>
                  <S.BonusList>
                    {data.map((bonus) => {
                      const {
                        offerId,
                        nameKey,
                        bonusValue,
                        validTo,
                        offerQueueId,
                        offerPlayerInfo = {},
                      } = bonus;
                      const { imageUrl, rulesPageUrl } = offerPlayerInfo;
                      const bonusItem = (
                        <S.BonusItem key={offerId}>
                          <S.BonusHeader>
                            <S.BonusTitle data-translation={nameKey}>
                              {translation(nameKey)}
                            </S.BonusTitle>
                          </S.BonusHeader>

                          <S.BonusImageWrapper ratio={2}>
                            {imageUrl && <S.BonusImage src={`${imageUrl}`} />}
                          </S.BonusImageWrapper>

                          <S.BonusBody>
                            <S.BonusBox>
                              <S.BonusBoxTitle>
                                {translation('account_bonus_amount')}
                              </S.BonusBoxTitle>
                              <S.BonusBoxValue>
                                {bonusValue != undefined ? formatMoney(bonusValue) : ''}&nbsp;{currencyCode}
                              </S.BonusBoxValue>
                            </S.BonusBox>

                            <S.BonusBox>
                              <S.BonusBoxTitle>
                                {translation('account_bonus_validToDate')}
                              </S.BonusBoxTitle>
                              <S.BonusBoxValue>
                                {formatDate(validTo, 'yyyy-MM-dd HH:mm')}
                              </S.BonusBoxValue>
                            </S.BonusBox>

                            <S.BonusBox>
                              <S.ActivateButton
                                onClick={this.renderBonusActionConfirmation.bind(
                                  this,
                                  offerQueueId,
                                  'activate'
                                )}
                              >
                                {translation('account_bonus_use')}
                              </S.ActivateButton>
                            </S.BonusBox>
                          </S.BonusBody>

                          <S.BonusFooter>
                            <S.BonusRegulationLink
                              href={rulesPageUrl ? rulesPageUrl : '/'}
                              target="_blank"
                            >
                              {translation('account_bonus_regulationLink')}
                            </S.BonusRegulationLink>
                          </S.BonusFooter>
                        </S.BonusItem>
                      );
                      return bonusItem;
                    })}
                  </S.BonusList>
                  <Pagination
                    {...{ currentPage, limit, data, callback: this.goPage, isNextPageAvailable }}
                  />
                </>
              ) : (
                <S.NoResult>{translation('account_bonus_notFound')}</S.NoResult>
              )}
            </S.BonusListWrapper>
          </>
        )}
      </S.AccountQueueBonus>
    );
  }
}

const mapStateToProps = ({
  AccountBonus: { isPending, error, startDate, endDate, activeTab, limit, bonus },
  Auth: {
    user: { currencyCode },
  },
}) => {
  return {
    error,
    isPending,
    startDate,
    endDate,
    activeTab,
    limit,
    bonus,
    currencyCode,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentPage: bindActionCreators(setCurrentPage, dispatch),
    fetchCreditBonusListByFilter: bindActionCreators(fetchCreditBonusListByFilter, dispatch),
    fetchCreditBonusListPending: bindActionCreators(fetchCreditBonusListPending, dispatch),
    fetchCreditBonusListFulfilled: bindActionCreators(fetchCreditBonusListFulfilled, dispatch),
    fetchCreditBonusListFailure: bindActionCreators(fetchCreditBonusListFailure, dispatch),
    manageCreditBonus: bindActionCreators(manageCreditBonus, dispatch),
    loadCustomerData: bindActionCreators(loadCustomerData, dispatch),
    processFrontError: bindActionCreators(proccessFrontError, dispatch),
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountQueueBonus);
